import { Dialog, DialogTitle } from 'components/Dialog';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import React, { useEffect, useId } from 'react';
import { selectInviteAvailable } from 'features/permissions/permissionsSlice';
import InviteUser from './InviteUser';

const InviteUserModal = () => {
  const { t } = useTranslation('modals');
  const dispatch = useAppDispatch();

  const prefix = useId();

  const isInviteAvailable = useAppSelector(selectInviteAvailable);

  const shouldClose = !isInviteAvailable;

  useEffect(() => {
    if (shouldClose) {
      dispatch(closeModal('inviteUser'));
    }
  }, [shouldClose, dispatch]);

  const handleClose = () => {
    dispatch(closeModal('inviteUser'));
  };

  return (
    <Dialog
      open={!shouldClose}
      maxWidth="xs"
      onClose={handleClose}
      aria-labelledby={`${prefix}-title`}
    >
      <DialogTitle id={`${prefix}-title`} onClose={handleClose}>
        {t('invite_participants.title')}
      </DialogTitle>
      <InviteUser />
    </Dialog>
  );
};

export default InviteUserModal;
